import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchTimelineSetByTournamentIdAPI } from "./timelinesAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  results: [],
  cache: {},
  status: "idle",
  error: null,
};

export const fetchTimelineSetByTournamentId = createAsyncThunk(
  "timelines/fetchTimelinesByTournamentId",
  async (tournamentId, { dispatch, rejectWithValue }) => {
    try {
      const response = await fetchTimelineSetByTournamentIdAPI(tournamentId);
      return {
        tournamentId,
        data: Array.isArray(response?.data) ? response.data : [],
      };
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

const timelinesSlice = createSlice({
  name: "timelines",
  initialState,
  reducers: {
    resetTimelines: (state) => {
      state.results = [];
    },
    updateResultsFromCache: (state, action) => {
      state.results = action.payload;
      state.status = "succeeded";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimelineSetByTournamentId.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTimelineSetByTournamentId.fulfilled, (state, action) => {
        const { tournamentId, data } = action.payload;
        state.cache[tournamentId] = data;
        state.results = data;
        state.status = "succeeded";
      })
      .addCase(fetchTimelineSetByTournamentId.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetTimelines } = timelinesSlice.actions;

export default timelinesSlice.reducer;
